import { render, staticRenderFns } from "./DataUnavailable.vue?vue&type=template&id=40c5afe8"
import script from "./DataUnavailable.vue?vue&type=script&lang=js"
export * from "./DataUnavailable.vue?vue&type=script&lang=js"
import style0 from "./DataUnavailable.vue?vue&type=style&index=0&id=40c5afe8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
